import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import { Formula } from '../types/Formula'
import formulasEndpoints from '../api/formulasEndpoints'
import formulaQueryKeys from '../queries/formulaQueryKeys'

export const fetchFormulas = ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof formulaQueryKeys)['list']>>) => {
  if (!companyId) return []
  return backendRequest<Formula[]>({
    method: GET,
    url: formulasEndpoints.list(companyId),
    signal
  })
}

export const createFormula = (data: Partial<Formula>, companyId: string) => {
  return backendRequest<Formula>({
    method: POST,
    url: formulasEndpoints.list(companyId),
    data
  })
}

export const updateFormula = (id: number, data: Partial<Formula>, companyId: string) => {
  return backendRequest<Formula>({
    method: PUT,
    url: formulasEndpoints.detail(companyId, id),
    data
  })
}

export const updateFormulaOrder = (data: Partial<Formula>[], companyId: string) => {
  return backendRequest<Formula[]>({
    method: PUT,
    url: formulasEndpoints.order(companyId),
    data
  })
}

export const deleteFormula = (companyId: string, id: number) => {
  return backendRequest<Formula>({
    method: DELETE,
    url: formulasEndpoints.detail(companyId, id)
  })
}
